// Note: The first file of a module here, must also register the module

import "./create-talking-point.component";
import "./talking-points.component";
import "./talking-point-list.component";
